import ModalAddEditTermCategory from "./modal-add-edit-term";

export default ModalAddEditTermCategory;